import { User, Building, Briefcase, Book, PenTool } from "lucide-react";

export function SocialStats() {
  return (
    <div className="space-y-4">
      <h2 className="text-2xl font-bold text-[#151C62] mb-12 text-center">
        About Nilesh Gajjar
      </h2>
      <div className="flex items-center justify-between p-4 bg-blue-50 rounded-lg">
        <div className="flex items-center space-x-3">
          <User className="h-5 w-5 text-blue-600" />
          <span className="font-medium">Member of AMA, Ahmedabad</span>
        </div>
      </div>
      <div className="flex items-center justify-between p-4 bg-sky-50 rounded-lg">
        <div className="flex items-center space-x-3">
          <Building className="h-5 w-5 text-sky-600" />
          <span className="font-medium">Member of AIFTP, Mumbai</span>
        </div>
      </div>
      <div className="flex items-center justify-between p-4 bg-red-50 rounded-lg">
        <div className="flex items-center space-x-3">
          <Briefcase className="h-5 w-5 text-red-600" />
          <span className="font-medium">Member of AGFTC, Gujarat</span>
        </div>
      </div>
      <div className="flex items-center justify-between p-4 bg-purple-50 rounded-lg">
        <div className="flex items-center space-x-3">
          <Book className="h-5 w-5 text-purple-600" />
          <span className="font-medium">Registered GSTP</span>
        </div>
      </div>
      <div className="flex items-center justify-between p-4 bg-green-50 rounded-lg">
        <div className="flex items-center space-x-3">
          <PenTool className="h-5 w-5 text-green-600" />
          <span className="font-medium">Columnist with Karver Sahlaakar</span>
        </div>
      </div>
    </div>
  );
}
